import { HebDateUtil } from '../Util/HebDateUtil';
import { HDate } from '@hebcal/core';


const Header = (props) => {
  const prev = new Date(props.date - (1000*60*60*24));
  const next = new Date((props.date-0) + (1000*60*60*24));

  return (
    <div className='shiur-header'>
      <div className='shiur-buttons'>
          <a onClick={ () => { props.setDate(prev) } }>שיעור קודם</a>
          <b><a onClick={ () => { props.setDate(new Date()) } }>{ HebDateUtil.GetHebrewDateLong(new HDate(props.date)) }</a></b>
          <a onClick={ () => { props.setDate(next) } }>שיעור הבא</a>
      </div>
    </div>
  );
}

export default Header;